<template>
  <section class="features-section">
    <!-- Section Header -->
    <div class="features-header">
      <h3 class="features-title">
        <i>Simple</i>, Secure, Universal
      </h3>
      <p class="features-description">
        Crypto gift cards make sending crypto easy, even for people new to Web3. You don't need the recipient's wallet address – just purchase a gift card, top it up with USDC and share the link or QR code. They can redeem it whenever they're ready
      </p>
    </div>

    <!-- Features List -->
    <div class="features-list">
      <!-- Section Title -->
      <div class="features-list-header">
        <h4 class="features-subtitle">
          Why a crypto gift card is the perfect choice
        </h4>
      </div>

      <!-- Feature Cards -->
      <div
        v-for="feature in features"
        :key="feature.id"
        class="feature-card"
      >
        <h5 class="feature-card-title">
          {{ feature.icon }} {{ feature.title }}
        </h5>
        <p class="feature-card-description">
          {{ feature.description }}
        </p>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const features = [
  {
    id: 1,
    icon: '🔗',
    title: 'No wallet address required',
    description: 'Just send a link or QR code'
  },
  {
    id: 2,
    icon: '🌎',
    title: 'Instant & borderless',
    description: 'Send USDC to and from anywhere in the world'
  },
  {
    id: 3,
    icon: '🛡️',
    title: 'Secure by design',
    description: 'Every card is protected by unique one-time codes. Only you and the recipient have access to the money, which is safely stored until redemption'
  },
  {
    id: 4,
    icon: '💳',
    title: 'Pay your way',
    description: 'With a card or with crypto'
  },
  {
    id: 5,
    icon: '🧑‍🎨',
    title: 'The personal touch',
    description: 'Include a message or customize the look of your card'
  },
  {
    id: 6,
    icon: '🙌',
    title: 'Convenient for everyone',
    description: 'No crypto experience required'
  }
]
</script>

<style scoped>
.features-section {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 16px;
  gap: 24px;
  background: #4B71EE;
  border-radius: 24px;
  max-width: 100%;
  overflow: hidden;
}

.features-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 8px;
  align-self: stretch;
}

.features-title {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 29px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  align-self: stretch;
}

.features-description {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 15px;
  line-height: 18px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  align-self: stretch;
}

.features-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  gap: 4px;
  align-self: stretch;
}

.features-list-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px 0px;
  gap: 10px;
  align-self: stretch;
}

.features-subtitle {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: 0.01em;
  color: #FFFFFF;
  flex-grow: 1;
}

.feature-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px 12px;
  gap: 8px;
  background: #FFFFFF;
  border-radius: 12px;
  align-self: stretch;
}

.feature-card-title {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  letter-spacing: 0.01em;
  color: #182855;
  align-self: stretch;
}

.feature-card-description {
  font-family: 'Inter Tight', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 16px;
  letter-spacing: 0.01em;
  color: #182855;
  align-self: stretch;
}
</style>
